import { IApplicationState } from '../../types/redux';

export function getFullUrl(state: IApplicationState) {
  return state.newbuilding.fullUrl;
}
